import React, { useState } from "react";
import { toast } from "react-toastify";
import { createSanctionLetter } from "../../services/AdminPortal/sanctionLetterAPI";

export default function AddSanctionLetterForm({ onCancel, onSave }) {
  const [sanctionLetterNo, setSanctionLetterNo] = useState(
    `SL-${new Date().getFullYear()}-${Math.floor(Math.random() * 9000 + 1000)}`
  );
  const [sanctionDate, setSanctionDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [applicantName, setApplicantName] = useState("");
  const [coApplicant, setCoApplicant] = useState({
    name: "",
    relation: "",
    phone: "",
  });
  const [address, setAddress] = useState({
    street: "",
    city: "",
    state: "",
    pin: "",
  });
  const [loan, setLoan] = useState({
    loanType: "Medical",
    sanctionedAmount: "",
    roi: "",
    tenure: "",
    emiAmount: "",
    processingFee: "",
    modeOfDisbursement: "Direct Credit to Bank Account",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!applicantName || !address.street || !address.city || !address.state || !address.pin ||
        !loan.sanctionedAmount || !loan.roi || !loan.tenure || !loan.emiAmount || !loan.processingFee) {
      toast.error("Please fill all required fields!");
      return;
    }
    
    const payload = {
      sanctionLetterNo,
      sanctionDate,
      applicantName,
      coApplicantName: coApplicant.name || "",
      coApplicantRelation: coApplicant.relation || "",
      coApplicantPhone: coApplicant.phone || "",
      address: address.street,
      city: address.city,
      state: address.state,
      pin: address.pin,
      loanType: loan.loanType,
      sanctionedAmount: loan.sanctionedAmount,
      roi: loan.roi,
      tenure: loan.tenure,
      emiAmount: loan.emiAmount,
      processingFee: loan.processingFee,
      modeOfDisbursement: loan.modeOfDisbursement,
    };

    try {
      const response = await createSanctionLetter(payload);
      console.log('Success:', response);
      toast.success("Sanction Letter created successfully!");
      if (onSave) onSave(response.data);
      onCancel();
    } catch (err) {
      console.error('Full error:', err.response?.data || err.message);
      toast.error(err.response?.data?.error || "Failed to create Sanction Letter!");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-[#0d0d0d] p-6 rounded-lg shadow-lg text-white text-sm overflow-y-auto max-h-[90vh]"
    >
      {/* Sanction Info */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="text-gray-400 text-sm block mb-1">
            Sanction Letter No
          </label>
          <input
            type="text"
            value={sanctionLetterNo}
            onChange={(e) => setSanctionLetterNo(e.target.value)}
            className="w-full px-3 py-2 rounded bg-[#131313] border border-[#444]"
          />
        </div>
        <div>
          <label className="text-gray-400 text-sm block mb-1">
            Sanction Date
          </label>
          <input
            type="date"
            value={sanctionDate}
            onChange={(e) => setSanctionDate(e.target.value)}
            className="w-full px-3 py-2 rounded bg-[#131313] border border-[#444]"
          />
        </div>
      </div>

      <hr className="my-4 border-[#333]" />

      {/* Applicant */}
      <h3 className="font-semibold text-yellow-400">Applicant Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
        <input
          placeholder="Applicant Name"
          value={applicantName}
          onChange={(e) => setApplicantName(e.target.value)}
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
          required
        />
        <input
          placeholder="Co-Applicant Name"
          value={coApplicant.name}
          onChange={(e) =>
            setCoApplicant({ ...coApplicant, name: e.target.value })
          }
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
        />
        <input
          placeholder="Relation"
          value={coApplicant.relation}
          onChange={(e) =>
            setCoApplicant({ ...coApplicant, relation: e.target.value })
          }
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
        />
        <input
          placeholder="Co-Applicant Phone"
          value={coApplicant.phone}
          onChange={(e) =>
            setCoApplicant({ ...coApplicant, phone: e.target.value })
          }
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
        />
      </div>

      <hr className="my-4 border-[#333]" />

      {/* Address */}
      <h3 className="font-semibold text-yellow-400">Address</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
        <input
          placeholder="Street / Address"
          value={address.street}
          onChange={(e) => setAddress({ ...address, street: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
          required
        />
        <input
          placeholder="City"
          value={address.city}
          onChange={(e) => setAddress({ ...address, city: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
          required
        />
        <input
          placeholder="State"
          value={address.state}
          onChange={(e) => setAddress({ ...address, state: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
          required
        />
        <input
          placeholder="PIN"
          value={address.pin}
          onChange={(e) => setAddress({ ...address, pin: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
          required
        />
      </div>

      <hr className="my-4 border-[#333]" />

      {/* Loan Info */}
      <h3 className="font-semibold text-yellow-400">Loan Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
        <select
          value={loan.loanType}
          onChange={(e) => setLoan({ ...loan, loanType: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
        >
          <option>Medical</option>
          <option>Education</option>
          <option>Personal</option>
          <option>Other</option>
        </select>
        <input
          placeholder="Sanctioned Amount"
          value={loan.sanctionedAmount}
          onChange={(e) =>
            setLoan({ ...loan, sanctionedAmount: e.target.value })
          }
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
          required
        />
        <input
          placeholder="ROI (%)"
          value={loan.roi}
          onChange={(e) => setLoan({ ...loan, roi: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
          required
        />
        <input
          placeholder="Tenure (months)"
          value={loan.tenure}
          onChange={(e) => setLoan({ ...loan, tenure: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
          required
        />
        <input
          placeholder="EMI Amount"
          value={loan.emiAmount}
          onChange={(e) => setLoan({ ...loan, emiAmount: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
          required
        />
        <input
          placeholder="Processing Fee"
          value={loan.processingFee}
          onChange={(e) => setLoan({ ...loan, processingFee: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
          required
        />
        <input
          placeholder="Mode of Disbursement"
          value={loan.modeOfDisbursement}
          onChange={(e) => setLoan({ ...loan, modeOfDisbursement: e.target.value })}
          className="px-3 py-2 rounded bg-[#131313] border border-[#444]"
        />
      </div>

      {/* Action Buttons */}
      <div className="flex justify-between mt-6">
        <button
          type="button"
          onClick={onCancel}
          className="bg-[#2b2b2b] text-white px-4 py-2 rounded text-sm border border-[#444]"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="bg-yellow-400 text-black px-4 py-2 rounded text-sm font-semibold"
        >
          Save Sanction Letter ✓
        </button>
      </div>
    </form>
  );
}
